import { DialogContent } from '@material-ui/core';
import PropTypes from 'prop-types';

import { IconLongForm } from 'src/assets/icons/IconLongForm';
import { IconShortForm } from 'src/assets/icons/IconShortForm';
import { CustomDialog } from 'src/components/CustomDialog';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { PROJECT_TYPE } from 'src/data/project';

import { ProjectTypeButton } from './components/ProjectTypeButton';
import { useStyles } from './useStyles';

export const SelectNewProjectTypePopup = ({
  open,
  title,
  description,
  onSubmit,
  onClose,
  displayBackButton,
}) => {
  const styles = useStyles();

  return (
    <CustomDialog
      className={styles.root}
      open={open}
      onClose={onClose}
      onBack={onClose}
      title={title || 'What type of content are you creating?'}
      displayBackButton={displayBackButton}
      data-testid="popupSelectNewProjectType"
      displayCloseIcon
      hideActions
    >
      <DialogContent className={styles.dialogContent}>
        {description && (
          <CustomTypography
            className={styles.description}
            variant={TYPOGRAPHY_VARIANT.regular16}
          >
            {description}
          </CustomTypography>
        )}

        <ProjectTypeButton
          className={styles.button}
          Icon={IconLongForm}
          title="Long form"
          description="Blog posts, landing pages, emails, other..."
          onClick={() => onSubmit({ projectType: PROJECT_TYPE.longFormBuilder })}
          data-testid="buttonLongForm"
        >
          Long form
        </ProjectTypeButton>

        <ProjectTypeButton
          className={styles.button}
          Icon={IconShortForm}
          title="Short form"
          description="Ads, social posts, product descriptions, other..."
          onClick={() => onSubmit({ projectType: PROJECT_TYPE.document })}
          data-testid="buttonShortForm"
        >
          Short form
        </ProjectTypeButton>
      </DialogContent>
    </CustomDialog>
  );
};

SelectNewProjectTypePopup.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  displayBackButton: PropTypes.bool,
};
SelectNewProjectTypePopup.defaultProps = {
  title: null,
  description: null,
  displayBackButton: false,
};
